import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'semantic-ui-react'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { ManagerQuery } from '~/QueryHooks/ManagerQuery'
import { Nullable } from '~/types'

type DataFilterType = {
  rows: number,
  page: number,
  month: string
  farmerId: string
}

const ManagerDeliveries: React.FC = () => {
  const { t } = useTranslation()
  const [tableColumnHeaders, setTableColumnHeaders] = useState([
    {
      name: t('Tour data id'),
      key: 'uniqueId',
      sorted: 'desc'
    },
    {
      name: t('Date'),
      key: 'date',
      type: 'date',
      format: 'DD.MM.YYYY HH:mm',
      sorted: 'desc'
    },
    {
      name: t('Date start'),
      key: 'timeFrom'
    },
    {
      name: t('Date end'),
      key: 'timeTo'
    },
    {
      name: t('Amount accepted (in l)'),
      key: 'amount',
      type: 'no-unit-number',
      decimalScale: 0,
      sorted: 'desc'
    },
    {
      name: t('Acceptance quantity (in kg)'),
      key: 'amountInKg',
      type: 'no-unit-number',
      decimalScale: 0,
      sorted: 'desc'
    },
    {
      name: t('avg. Temp. (°C)'),
      key: 'avgTemp',
      type: 'no-unit-number',
      decimalScale: 1,
      sorted: 'desc'
    },
    {
      name: t('Sample bottle'),
      key: 'sampleBottleNumber'
    },
    {
      name: t('Sample Compartment Temp (°C)'),
      key: 'sampleAvgTemp',
      type: 'no-unit-number',
      decimalScale: 1,
      sorted: 'desc'
    }
  ])

  const [dataFiltered, setDataFiltered] = useState<Nullable<DataFilterType>>(null)

  const {
    data: options,
    isLoading: isLoadingOptions
  } = ManagerQuery.getDeliveriesIndexData()

  const {
    data: deliveriesData,
    isLoading: isLoadingList,
    isFetching: isFetchingList,
    refetch: fetchData
  } = ManagerQuery.getDeliveriesIndex( dataFiltered && {
    ...dataFiltered,
    page: dataFiltered?.page === 0 ? dataFiltered.page : dataFiltered?.page - 1
  })

  useEffect(() => {
    if (!dataFiltered && options?.months?.length) {
      setDataFiltered({
        rows: 20,
        page: 0,
        month: options.months[0].key,
        farmerId: options?.farmers[0]?.id
      })
    }
  }, [options, dataFiltered])

  useEffect(() => {
    if (dataFiltered) {
      fetchData()
    }
  }, [dataFiltered])

  function renderFilters() {
    return <>
      <Dropdown
        selectOnBlur={false}
        placeholder={t('Delivery month tour')}
        selection
        options={options?.months?.map(option => ({ text: option.label, value: option.key })) || []}
        value={dataFiltered?.month}
        onChange={(_, { value }) => setDataFiltered({ ...dataFiltered, month: value as string })}
      />
    </>
  }

  function renderTable() {
    return <TableComponent
      rows={rows}
      total={filtered}
      tableColumnHeaders={tableColumnHeaders}
      isFetchingData={isFetchingList}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data, tableColumnHeaders) => {
        setDataFiltered(data)
        setTableColumnHeaders(tableColumnHeaders)
      }}
      animated
    />
  }

  function renderActions() {
    return <>
      <Dropdown
        selection
        options={options?.farmers?.map(farmer => ({ value: farmer.id, text: farmer.companyName })) || []}
        value={dataFiltered?.farmerId}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            farmerId: value as string
          })
        }}
        placeholder='Betrieb wählen'
        />
    </>
  }

  const { filtered, rows } = deliveriesData ? deliveriesData : { filtered: 0, rows: [] }
  const isLoading = isLoadingList || isLoadingOptions

  return <Layout
    title={t('Deliveries')}
    actions={renderActions()}
    segmented
    isBusy={isLoading}
    filters={renderFilters()}
  >
    {dataFiltered && deliveriesData && renderTable()}
  </Layout>
}

export default ManagerDeliveries
